import { useQueryClient } from "@tanstack/react-query";
import { useRef, useState } from "react";
import { useParams } from "react-router";
import { toast } from "sonner";
import { endpoints } from "../../../hooks/endpoints";
import { getToken } from "../../../hooks/utils";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { invokeUserRefetch } from "../../../store/slices/storeSlice";

const CodePurchase = ({ lessonData, isMobile }) => {
  const [isPending, setIsPending] = useState(false);
  const [error, setError] = useState(null);
  const dispatch = useAppDispatch();
  const queryClient = useQueryClient();
  const { lesson } = useParams();
  const { userProfileData } = useAppSelector((state) => state.store);

  const codeRef = useRef(null);

  const handlePurchase = (e) => {
    e.preventDefault();
    setIsPending(true);
    const code = codeRef.current.value;
    fetch(
      endpoints.codePurchase +
        "?code=" +
        (code as string).trim() +
        "&lesson=" +
        lessonData.lesson_id +
        "&ismobile=" +
        isMobile,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: getToken(),
        },
        // signal: abortCont.signal
      }
    )
      .then((response) => response.json())
      .then((result) => {
        console.log("this is result: ", result);
        if (
          result !== "هذا الكود مستخدم من قبل , تواصل مع المدرس" &&
          result !== "الكود غير صحيح" &&
          result !== "هذا الكود غير مخصص لهذه الحصة"
        ) {
          dispatch(invokeUserRefetch());
          queryClient.invalidateQueries({
            queryKey: ["lesson", lesson, userProfileData],
          });
        } else {
          setError(result);
        }
        setIsPending(false);
      })
      .catch((err) => {
        console.log(err);
        setError("حدث خطأ");
        setIsPending(false);
      });
  };

  if (error) toast.error(error);

  return (
    <form className="mx-auto w-full md:w-1/2" onSubmit={handlePurchase}>
      <div className="block space-y-4">
        <div className="w-full">
          <label htmlFor="floatingInput" className="block mb-2 font-bold">
            أدخل الكود
          </label>
          <input
            type="text"
            id="floatingInput"
            placeholder="XXXX-XXXX-XXXX"
            required
            ref={codeRef}
            className="rounded-lg border border-gray-300 px-4 py-2 w-full focus:outline-none focus:ring-2 focus:ring-primary"
          />
        </div>

        {!isPending && (
          <button
            type="submit"
          
            className="block mx-auto px-6 py-2 bg-primary text-white font-bold rounded-lg hover:bg-primary/90 transition"
          >شراء</button>
        )}

        {isPending && (
          <button
            type="button"
            disabled
            className="flex items-center px-6 py-2 bg-primary text-white rounded-lg font-bold cursor-not-allowed mx-auto"
          >
            <svg
              className="animate-spin h-4 w-4 mx-2 text-white"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
            >
              <circle
                className="opacity-25"
                cx="12"
                cy="12"
                r="10"
                stroke="currentColor"
                strokeWidth="4"
              ></circle>
              <path
                className="opacity-75"
                fill="currentColor"
                d="M4 12a8 8 0 018-8v8H4z"
              ></path>
            </svg>
            شراء...
          </button>
        )}
      </div>
    </form>
  );
};

export default CodePurchase;
